// Guarded localStorage. Private mode, a quota, or a blocked API must not
// take the panel with them — the flag just starts from its fallback.

export function readLocalFlag(key: string, fallback: boolean): boolean {
  try {
    const raw = window.localStorage.getItem(key);
    if (raw === null) return fallback;
    return raw === '1';
  } catch {
    return fallback;
  }
}

export function writeLocalFlag(key: string, value: boolean): void {
  try {
    window.localStorage.setItem(key, value ? '1' : '0');
  } catch {
    // Storage is unavailable. The panel still opens and closes for this visit.
  }
}
